import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-about-background bg-top pb-20 bg-[length:130rem] h-full bg-no-repeat bg-white pt-20" }
const _hoisted_2 = { class: "max-w-screen-lg px-4 mx-auto" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_5 = {
  key: 1,
  class: "text-sm text-red-600"
}
const _hoisted_6 = {
  key: 2,
  class: "space-y-10"
}
const _hoisted_7 = {
  key: 0,
  class: "overflow-hidden bg-white border border-gray-200 rounded-2xl"
}
const _hoisted_8 = ["alt", "src"]
const _hoisted_9 = { class: "rounded-2xl border border-gray-200 bg-[#f6f1ec] p-8 shadow-sm" }
const _hoisted_10 = { class: "flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between" }
const _hoisted_11 = { class: "max-w-3xl" }
const _hoisted_12 = { class: "mt-3 text-2xl font-semibold text-gray-900 md:text-3xl" }
const _hoisted_13 = { class: "flex flex-wrap items-center gap-3 mt-4 text-sm text-gray-700" }
const _hoisted_14 = { class: "px-3 py-1 text-xs font-medium text-gray-600 bg-white rounded-full" }
const _hoisted_15 = {
  key: 0,
  class: "px-3 py-1 text-xs font-medium text-gray-600 bg-white rounded-full"
}
const _hoisted_16 = {
  key: 1,
  class: "px-3 py-1 text-xs font-medium text-gray-600 bg-white rounded-full"
}
const _hoisted_17 = {
  key: 2,
  class: "px-3 py-1 text-xs font-medium text-gray-600 bg-white rounded-full"
}
const _hoisted_18 = { class: "flex flex-col items-start gap-3 lg:items-end" }
const _hoisted_19 = { class: "flex flex-col w-full gap-3 sm:w-56" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "grid gap-8 lg:grid-cols-[2fr,1fr]" }
const _hoisted_22 = { class: "space-y-8" }
const _hoisted_23 = { class: "p-6 bg-white border border-gray-200 shadow-sm rounded-2xl" }
const _hoisted_24 = { class: "mt-3 text-sm leading-6 text-gray-700" }
const _hoisted_25 = { class: "p-6 bg-white border border-gray-200 shadow-sm rounded-2xl" }
const _hoisted_26 = { class: "grid gap-3 mt-4 sm:grid-cols-2" }
const _hoisted_27 = { class: "space-y-6" }
const _hoisted_28 = { class: "p-6 bg-white border border-gray-200 shadow-sm rounded-2xl" }
const _hoisted_29 = { class: "grid gap-4 mt-4 text-sm text-gray-700" }
const _hoisted_30 = { class: "flex items-center justify-between" }
const _hoisted_31 = { class: "font-medium text-gray-900" }
const _hoisted_32 = { class: "flex items-center justify-between" }
const _hoisted_33 = { class: "font-medium text-gray-900" }
const _hoisted_34 = { class: "flex items-center justify-between" }
const _hoisted_35 = { class: "font-medium text-gray-900" }
const _hoisted_36 = { class: "flex items-center justify-between" }
const _hoisted_37 = { class: "font-medium text-gray-900" }
const _hoisted_38 = { class: "flex items-center justify-between" }
const _hoisted_39 = { class: "font-medium text-gray-900" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { key: 2 }
const _hoisted_43 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowLeftIcon = _resolveComponent("ArrowLeftIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ShareIcon = _resolveComponent("ShareIcon")!
  const _component_PencilSquareIcon = _resolveComponent("PencilSquareIcon")!
  const _component_TicketIcon = _resolveComponent("TicketIcon")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "text-sm font-medium text-gray-900 hover:text-primary",
          to: "/dashboard/events"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ArrowLeftIcon, { class: "inline w-4 h-4 mr-2" }),
            _cache[1] || (_cache[1] = _createTextVNode(" Back to Events "))
          ]),
          _: 1
        })
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Loading event... "))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_ctx.bannerImageSrc)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("img", {
                      alt: _ctx.event?.title || 'Event banner',
                      src: _ctx.bannerImageSrc,
                      class: "h-[600px] w-full object-cover"
                    }, null, 8, _hoisted_8)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-xs uppercase tracking-[0.2em] text-gray-500" }, " Event Details ", -1)),
                    _createElementVNode("h1", _hoisted_12, _toDisplayString(_ctx.event?.title), 1),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.formatDate(_ctx.event?.date)), 1),
                      (_ctx.event?.startTime || _ctx.event?.endTime)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.formatTimeRange(_ctx.event?.startTime, _ctx.event?.endTime)), 1))
                        : _createCommentVNode("", true),
                      (_ctx.event?.location)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.event.location), 1))
                        : _createCommentVNode("", true),
                      (_ctx.event?.type)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.event.type), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_router_link, {
                        class: "inline-flex items-center justify-center w-full px-5 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-full hover:bg-gray-100",
                        to: "/dashboard/events"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ArrowLeftIcon, { class: "w-4 h-4 mr-2" }),
                          _cache[3] || (_cache[3] = _createTextVNode(" Back to Events "))
                        ]),
                        _: 1
                      }),
                      _createElementVNode("button", {
                        class: "inline-flex items-center justify-center w-full px-5 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-full hover:bg-gray-100",
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.shareEvent && _ctx.shareEvent(...args)))
                      }, [
                        _createVNode(_component_ShareIcon, { class: "w-4 h-4 mr-2" }),
                        _cache[4] || (_cache[4] = _createTextVNode(" Share "))
                      ]),
                      (_ctx.user?.role === 'admin')
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "inline-flex items-center justify-center w-full px-5 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-full hover:bg-gray-100",
                            to: `/administrator/events/${_ctx.id}`
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_PencilSquareIcon, { class: "w-4 h-4 mr-2" }),
                              _cache[5] || (_cache[5] = _createTextVNode(" Edit Event "))
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : _createCommentVNode("", true)
                    ]),
                    (!_ctx.user)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          class: "inline-flex w-full items-center justify-center rounded-full bg-primary px-5 py-2 text-sm font-semibold text-black hover:bg-[#c9ad99] sm:w-56",
                          to: "/login"
                        }, {
                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createTextVNode(" Log in to reserve ")
                          ])),
                          _: 1
                        }))
                      : (_ctx.event?.ticketUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            class: "inline-flex w-full items-center justify-center rounded-full bg-primary px-5 py-2 text-sm font-semibold text-black hover:bg-[#c9ad99] sm:w-56",
                            href: _ctx.event.ticketUrl,
                            rel: "noreferrer",
                            target: "_blank"
                          }, [
                            _createVNode(_component_TicketIcon, { class: "w-4 h-4 mr-2" }),
                            _cache[7] || (_cache[7] = _createTextVNode(" Reserve your spot "))
                          ], 8, _hoisted_20))
                        : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "text-lg font-semibold text-gray-900" }, " Overview ", -1)),
                    _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.event?.description || 'Join this exclusive member event to connect with peers, share insights, and expand your investor network.'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "text-lg font-semibold text-gray-900" }, " Who Should Join ", -1)),
                    _createElementVNode("div", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.whoShouldJoinItems, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item,
                          class: "px-4 py-2 text-xs font-medium text-gray-700 border border-gray-200 rounded-full"
                        }, _toDisplayString(item), 1))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("aside", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _cache[16] || (_cache[16] = _createElementVNode("h2", { class: "text-lg font-semibold text-gray-900" }, " Event Details ", -1)),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-gray-500" }, "Date", -1)),
                        _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.formatDate(_ctx.event?.date)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-gray-500" }, "Time", -1)),
                        _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.formatTimeRange(_ctx.event?.startTime, _ctx.event?.endTime) || 'TBA'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-gray-500" }, "Location", -1)),
                        _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.event?.location || 'TBA'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-gray-500" }, "Type", -1)),
                        _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.event?.type || 'Member Event'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-gray-500" }, "Price", -1)),
                        _createElementVNode("span", _hoisted_39, [
                          (_ctx.event?.hidePrice)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_40, "Paid event"))
                            : (typeof _ctx.event?.price === 'number')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_41, "£" + _toDisplayString(_ctx.formatPrice(_ctx.event.price)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_42, "Free"))
                        ])
                      ])
                    ]),
                    (!_ctx.user)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          class: "mt-5 inline-flex w-full items-center justify-center rounded-full bg-primary px-5 py-2 text-sm font-semibold text-black hover:bg-[#c9ad99]",
                          to: "/login"
                        }, {
                          default: _withCtx(() => _cache[15] || (_cache[15] = [
                            _createTextVNode(" Log in to reserve ")
                          ])),
                          _: 1
                        }))
                      : (_ctx.event?.ticketUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            class: "mt-5 inline-flex w-full items-center justify-center rounded-full bg-primary px-5 py-2 text-sm font-semibold text-black hover:bg-[#c9ad99]",
                            href: _ctx.event.ticketUrl,
                            rel: "noreferrer",
                            target: "_blank"
                          }, " Get ticket ", 8, _hoisted_43))
                        : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
    ])
  ]))
}